export class PositionEditResult {
  constructor(node: HTMLElement) {
    this.block_id = node.dataset.block_id;
    const pos: any = node.getAttribute('position');
    this.x = pos.x;
    this.y = pos.y;
    this.z = pos.z;
  }
  public block_id: string;
  public x: number;
  public y: number;
  public z: number;
}
